module.exports = __webpack_public_path__ + "img/Christian-Munoz.b2987243.jpg";